import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useBank } from '@/providers/Bank.provider';
import { OnlineBankAccountRequestType } from './types';
import { OnlineBankAccountIdentificationId, TextField, FieldData, sanitizeToNumeric } from 'vopay';

export const buildOnlineBankingRows = (country: string): FieldData<OnlineBankAccountRequestType>[] => {
  const { AccountType } = useBank();
  const { t } = useTranslation('translations', { keyPrefix: 'ManualBank' });
  return [
    {
      label: () => t('firstName'),
      fieldName: OnlineBankAccountIdentificationId.FirstName,
      getInputState: () => 'required',
      showField: () => AccountType === undefined || AccountType === 'personal',
      serializeField: (values) => values.FirstName,
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});
        return <TextField variant="lined" preset="text" borderColor="#C4C4C4" {...fieldData} />;
      },
      validate: () =>
        AccountType === 'personal' ? Yup.mixed().required(`${t('firstNameErrorRequired')}`) : Yup.mixed(),
    },
    {
      label: () => t('lastName'),
      fieldName: OnlineBankAccountIdentificationId.LastName,
      getInputState: () => 'required',
      showField: () => AccountType === undefined || AccountType === 'personal',
      serializeField: (values) => values.LastName,
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});
        return <TextField variant="lined" preset="text" borderColor="#C4C4C4" {...fieldData} />;
      },
      validate: () => (AccountType === 'personal' ? Yup.mixed().required(`${t('lastNameErrorReqired')}`) : Yup.mixed()),
    },
    {
      label: () => t('companyName'),
      fieldName: OnlineBankAccountIdentificationId.CompanyName,
      getInputState: () => 'required',
      showField: () => AccountType === 'business',
      serializeField: (values) => values.CompanyName,
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});
        return <TextField variant="lined" preset="text" borderColor="#C4C4C4" {...fieldData} />;
      },
      validate: () =>
        AccountType === 'business' ? Yup.mixed().required(`${t('companyNameErrorRequired')}`) : Yup.mixed(),
    },
    {
      label: () => (AccountType === 'personal' ? t('driverLicense') : t('taxID')),
      fieldName: OnlineBankAccountIdentificationId.IdentificationNumber,
      getInputState: () => 'required',
      showField: () => country === 'US',
      serializeField: (values) => values.IdentificationNumber,
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});
        return <TextField variant="lined" preset="text" borderColor="#C4C4C4" {...fieldData} />;
      },
      validate: () => Yup.mixed().required(`${t('valueRequired')}`),
    },
    {
      label: () => `${t('phoneNumber')}`,
      fieldName: OnlineBankAccountIdentificationId.PhoneNumber,
      getInputState: () => 'required',
      showField: () => true,
      serializeField: (values) => sanitizeToNumeric(values.PhoneNumber),
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});

        return <TextField variant="lined" preset="tel" borderColor="#C4C4C4" {...fieldData} />;
      },
      validate: () => Yup.string().required(),
    },
  ];
};
